const CrowdWorksCompanyName = () => {
  return '株式会社クラウドワークス'
}

export default CrowdWorksCompanyName
